<template>
  <v-form class='pqrAsmeViewForm' v-model='valid' ref='pqrAsmeViewForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <div class="logo_box text-center">
            <img :src="$getCompanyData().url" height="150" width="200" />
          </div>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <h4>Procedure Qualification Record</h4>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Procedure No</label>
          <p>{{ pqrAsme.serial_no ? pqrAsme.serial_no : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Company Name</label>
          <p>{{ pqrAsme.company_name ? pqrAsme.company_name : '-' }}</p>
          <label class='view_label'>Company Address</label>
          <p>{{ pqrAsme.company_address ? pqrAsme.company_address : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Refrerred Standard</label>
          <p><v-chip small>{{ pqrAsme.referred_standard_name ? pqrAsme.referred_standard_name  : '-' }}</v-chip></p>
          <label class='view_label'>Welding Process</label>
          <p><v-chip small v-for="(item, index) in pqrAsme.wptwpr_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12' class="pt-0">
          <v-row>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev Date</label>
              <p>{{ pqrAsme.rev_date ? pqrAsme.rev_date : '-' }}</p>
            </v-col>
            <v-col :cols='colValue' md='4' sm='6' xs='12'>
              <label class='view_label'>Rev No</label>
              <p>{{ pqrAsme.rev_no ? pqrAsme.rev_no  : '-' }}</p>
            </v-col>
          </v-row>
          <label class='view_label'>Welding Type</label>
          <p><v-chip small v-for="(item, index) in pqrAsme.wptwt_id" :key="index">{{ item.text }}</v-chip></p>
        </v-col>
      </v-row>
      <h4 class="text-center">Joint Design</h4><hr>
      <v-row>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Joint Design (QW-402)</label>
          <p>{{ pqrAsme.joint_design ? pqrAsme.joint_design  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="4" sm="6" xs="12">
          <label class='view_label'>Joint Backing</label>
          <p><template><v-chip :color="pqrAsme.joint_backing == 0 ? 'warning' : 'success'" small>{{ pqrAsme.joint_backing == 0 ? 'No' : 'Yes' }}</v-chip></template></p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12'>
          <label class='view_label'>Backing Material</label>
          <p>{{ pqrAsme.joint_backing_material ? pqrAsme.joint_backing_material  : '-' }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols='colValue' md="12" xs="12">
          <label class='view_label'>Joint Drawings</label>
          <div class="upload_container">
            <v-row>
              <v-col v-for="(image, i) in pqrAsme.welding_procedure_drawing" :key="i" class="d-flex child-flex" cols="6">
                <div class="jointDrawings">
                  <v-row>
                    <v-col cols='12' md='5' sm='12' xs='12'>
                      <img height="150" width="200" :src="`${image.url}`" />
                    </v-col>
                    <v-col cols='12' md='7' sm='12' xs='12'>
                      <v-row>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>A : {{ image.param_a ? image.param_a : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>B : {{ image.param_b ? image.param_b : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>C : {{ image.param_c ? image.param_c : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>D : {{ image.param_d ? image.param_d : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>E : {{ image.param_e ? image.param_e : ''}}</p>
                        </v-col>
                        <v-col cols='12' md='2' sm='6' xs='12'>
                          <p>F : {{ image.param_f ? image.param_f : ''}}</p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <h4 class="text-center">Base Metals (QW-403)</h4><hr>
      <v-row v-for="(bm, bmi) in pqrAsme.base_metal" :key="bmi" class="pt-5">
        <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Base Metal</label>
              <p>{{ bm.base_metal ? bm.base_metal  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Name / Grade</label>
              <p>{{ bm.grade ? bm.grade  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Material Specification</label>
              <p>{{ bm.material_specification ? bm.material_specification  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>P No</label>
              <p>{{ bm.p_no ? bm.p_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Group No</label>
              <p>{{ bm.group_no ? bm.group_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Thickness</label>
              <p>{{ bm.thickness ? bm.thickness  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Groove Thickness Range</label>
              <p>{{ bm.groove_thickness_range ? bm.groove_thickness_range  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Fillet Thickness Range</label>
              <p>{{ bm.fillet_thickness_range ? bm.fillet_thickness_range  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Pipe Diameter Range</label>
              <p>{{ bm.pipe_diameter_range ? bm.pipe_diameter_range  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
        <div class="break_page">
          <h4 class="text-center mt-2">Filler Metals (QW-404)</h4><hr>
          <v-row v-for="(fm, ind) in pqrAsme.filler_metal" :key="`fm_${ind}`" class="pt-5">
            <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
              <v-row>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                  <label class='view_label'>Welding Process</label>
                  <p><v-chip small>{{ fm.wps_text ? fm.wps_text  : '-' }}</v-chip></p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                  <label class='view_label'>F No</label>
                  <p>{{ fm.f_no ? fm.f_no  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>A No</label>
                  <p>{{ fm.a_no ? fm.a_no  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Spec No</label>
                  <p>{{ fm.spec_no ? fm.spec_no  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                  <label class='view_label'>Aws Class</label>
                  <p>{{ fm.aws_class ? fm.aws_class  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Filler Size</label>
                  <p>{{ fm.filler_size ? fm.filler_size  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Deposited Weld Metal Thickness</label>
                  <p>{{ fm.deposited_weld_metal_thickness ? fm.deposited_weld_metal_thickness  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Groove</label>
                  <p>{{ fm.groove ? fm.groove  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Fillet</label>
                  <p>{{ fm.fillet ? fm.fillet  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Min Travel Speed</label>
                  <p>{{ fm.min_travel_speed ? fm.min_travel_speed  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Electrode Flux Class</label>
                  <p>{{ fm.electrode_flux_class ? fm.electrode_flux_class  : '-' }}</p>
                </v-col>
                <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                  <label class='view_label'>Remarks</label>
                  <p>{{ fm.remarks ? fm.remarks  : '-' }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      <v-row>
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Positions (QW-405)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Position Of Groove</label>
              <p>{{ pqrAsme.position_of_groove ? pqrAsme.position_of_groove : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Position Of Filler</label>
              <p>{{ pqrAsme.position_of_fillet ? pqrAsme.position_of_fillet : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='4' sm='4' xs='12'>
              <label class='view_label'>Welding Progression</label>
              <p>{{ pqrAsme.welding_progression ? pqrAsme.welding_progression : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Preheat (QW-406)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Preheat Temperature Min</label>
              <p>{{ pqrAsme.preheat_temperature_min ? pqrAsme.preheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Preheat Temperature Max</label>
              <p>{{ pqrAsme.preheat_temperature_max ? pqrAsme.preheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Interpass Temperature Min</label>
              <p>{{ pqrAsme.interpass_temperature_min ? pqrAsme.interpass_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Interpass Temperature Max</label>
              <p>{{ pqrAsme.interpass_temperature_max ? pqrAsme.interpass_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Preheat Maintenance</label>
              <p>{{ pqrAsme.preheat_maintenance ? pqrAsme.preheat_maintenance  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12" style="border-right:1px solid #ccc">
          <h4 class="text-center">Post Heat Treatment (QW-407)</h4><hr>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Postheat Temperature Min</label>
              <p>{{ pqrAsme.postheat_temperature_min ? pqrAsme.postheat_temperature_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Postheat Temperature Max</label>
              <p>{{ pqrAsme.postheat_temperature_max ? pqrAsme.postheat_temperature_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols='colValue' md='6' sm='6' xs='12'>
              <label class='view_label'>Time Min</label>
              <p>{{ pqrAsme.time_min ? pqrAsme.time_min  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Time Max</label>
              <p>{{ pqrAsme.time_max ? pqrAsme.time_max  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Remarks</label>
              <p>{{ pqrAsme.postheat_remark ? pqrAsme.postheat_remark  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <h4 class="text-center">Gas (QW-408)</h4><hr>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Shielding Gas</label>
              <p>{{ pqrAsme.shielding_gas ? pqrAsme.shielding_gas  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Composition %</label>
              <p>{{ pqrAsme.composition_per ? pqrAsme.composition_per  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Flow Rate</label>
              <p>{{ pqrAsme.flow_rate ? pqrAsme.flow_rate  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Gas Backing</label>
              <p>{{ pqrAsme.gas_backing ? pqrAsme.gas_backing  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Trailing Shielding Gas</label>
              <p>{{ pqrAsme.trailing_shielding_gas ? pqrAsme.trailing_shielding_gas  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Technique (QW-410)</h4><hr>
      <v-row>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>String or Weave Bead</label>
              <p>{{ pqrAsme.weave_bead ? pqrAsme.weave_bead  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Orifice / Gas Cup Size</label>
              <p>{{ pqrAsme.gas_cup_size ? pqrAsme.gas_cup_size  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Inital and Interpass Cleaning (Brushing,Grinding)</label>
              <p>{{ pqrAsme.cleaning ? pqrAsme.cleaning  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Method Of Back Gouging</label>
              <p>{{ pqrAsme.back_gouging_method ? pqrAsme.back_gouging_method  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Oscillation Frequency</label>
              <p>{{ pqrAsme.oscillation ? pqrAsme.oscillation  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Contact Tube Work Distance</label>
              <p>{{ pqrAsme.contact_tube_work_distance ? pqrAsme.contact_tube_work_distance  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Multiple Or Single Pass (perside)</label>
              <p>{{ pqrAsme.pass_perside ? pqrAsme.pass_perside  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="12" sm="12" xs="12">
              <label class='view_label'>Multiple Or Single Electrodes</label>
              <p>{{ pqrAsme.electrode ? pqrAsme.electrode  : '-' }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Peening</label>
              <p>{{ pqrAsme.peening ? pqrAsme.peening  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="6" sm="6" xs="12">
              <label class='view_label'>Electrode Spacing</label>
              <p>{{ pqrAsme.electrode_spacing ? pqrAsme.electrode_spacing  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Electrical Charecterstics (QW-409)</h4><hr>
      <v-row v-for="(wp, ind) in pqrAsme.welding_parameter" :key="`wp_${ind}`" class="pt-5">
        <v-col :cols="colValue" lg="11" md="11" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Welding Process</label>
              <p><v-chip small>{{ wp.wpm_wps_text ? wp.wpm_wps_text  : '-' }}</v-chip></p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Weld Layer</label>
              <p>{{ wp.weld_layer ? wp.weld_layer  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Class</label>
              <p>{{ wp.filler_class ? wp.filler_class  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Filler Size</label>
              <p>{{ wp.filler_size ? wp.filler_size  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Polarity</label>
              <p>{{ wp.wpm_plr_text ? wp.wpm_plr_text  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Current(A)</label>
              <p>{{ wp.min_current ? wp.min_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Current(A)</label>
              <p>{{ wp.max_current ? wp.max_current  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Voltage(V)</label>
              <p>{{ wp.min_voltage ? wp.min_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Voltage(V)</label>
              <p>{{ wp.max_voltage ? wp.max_voltage  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Travel Speed</label>
              <p>{{ wp.min_travel_speed ? wp.min_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Travel Speed</label>
              <p>{{ wp.max_travel_speed ? wp.max_travel_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Feed Speed</label>
              <p>{{ wp.min_feed_speed ? wp.min_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Feed Speed</label>
              <p>{{ wp.max_feed_speed ? wp.max_feed_speed  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Min Flow Rate</label>
              <p>{{ wp.min_flowrate ? wp.min_flowrate  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Max Flow Rate</label>
              <p>{{ wp.max_flowrate ? wp.max_flowrate  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="break_page">
        <h4 class="text-center mt-2">Tensile Test</h4><hr>
        <v-row v-for="(tt, tti) in pqrAsme.tensile_test" :key="`tt_${tti}`" class="pt-5">
          <v-col :cols="colValue" lg="12" md="12" sm="12" xs="12" class="py-0">
            <v-row>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Specimen No</label>
                <p>{{ tt.specimen_no ? tt.specimen_no  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0">
                <label class='view_label'>Width</label>
                <p>{{ tt.width ? tt.width  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Thickness</label>
                <p>{{ tt.thickness ? tt.thickness  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Area</label>
                <p>{{ tt.area ? tt.area  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Ultimate Total Load</label>
                <p>{{ tt.ultimate_total_load ? tt.ultimate_total_load  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Ultimate Unit Stress</label>
                <p>{{ tt.ultimate_unit_stress ? tt.ultimate_unit_stress  : '-' }}</p>
              </v-col>
              <v-col :cols="colValue" md="2" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
                <label class='view_label'>Type Of Failure And Location</label>
                <p>{{ tt.type_of_failure_and_location ? tt.type_of_failure_and_location  : '-' }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <h4 class="text-center mt-2">Guided Bend Tests</h4><hr>
      <v-row v-for="(gb, gbi) in pqrAsme.guided_bend_test" :key="`gb_${gbi}`" class="pt-5">
        <v-col :cols="colValue" lg="12" md="12" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Specimen No</label>
              <p>{{ gb.specimen_no ? gb.specimen_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Type And Figure No</label>
              <p>{{ gb.type_and_figure_no ? gb.type_and_figure_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Bend Test Angle</label>
              <p>{{ gb.bend_test_angle ? gb.bend_test_angle  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Result</label>
              <p>{{ gb.result ? gb.result  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h4 class="text-center mt-2">Toughness Tests</h4><hr>
      <v-row v-for="(tgt, tgti) in pqrAsme.toughness_test" :key="`tgt_${tgti}`" class="pt-5">
        <v-col :cols="colValue" lg="12" md="12" sm="12" xs="12" class="py-0">
          <v-row>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Specimen No</label>
              <p>{{ tgt.specimen_no ? tgt.specimen_no  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Width</label>
              <p>{{ tgt.width ? tgt.width  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Notch Location</label>
              <p>{{ tgt.notch_location ? tgt.notch_location  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Test Temperature</label>
              <p>{{ tgt.test_temperature ? tgt.test_temperature  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Impact Value % shear</label>
              <p>{{ tgt.impact_value ? tgt.impact_value  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Mils/mm</label>
              <p>{{ tgt.mils_mm ? tgt.mils_mm  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0 pb-0 pb-md-3">
              <label class='view_label'>Drop Weight Break</label>
              <p>{{ tgt.drop_weight_break ? tgt.drop_weight_break  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="colValue" md="6" sm="6" xs="12">
          <h4>Other Tests</h4><hr>
          <v-row v-for="(ot, oti) in pqrAsme.other_test" :key="`ot_${oti}`" class="pt-2">
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Test Paremeter:</label>
              <p>{{ ot.test_paremeter ? ot.test_paremeter  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Result</label>
              <p>{{ ot.result ? ot.result  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Remark</label>
              <p>{{ ot.remark ? ot.remark  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="colValue" md="6" sm="6" xs="12">
          <h4>Hardness Tests(BHN)</h4><hr>
          <v-row v-for="(ht, hti) in pqrAsme.hardness_test" :key="`ht_${hti}`" class="pt-2">
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Thickness:</label>
              <p>{{ ht.thickness ? ht.thickness  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Weld</label>
              <p>{{ ht.weld ? ht.weld  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Haz</label>
              <p>{{ ht.haz ? ht.haz  : '-' }}</p>
            </v-col>
            <v-col :cols="colValue" md="3" sm="4" xs="12" class="pt-0">
              <label class='view_label'>Base Material</label>
              <p>{{ ht.base_material ? ht.base_material  : '-' }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <label class='view_label'>Prepared By</label>
          <p>{{ pqrAsme.prepared_by ? pqrAsme.prepared_by  : '-' }}</p>
          <label class='view_label'>Prepared By Signature</label>
          <p>{{ pqrAsme.prepared_by_sign ? pqrAsme.prepared_by_sign  : '-' }}</p>
          <label class='view_label'>Date</label>
          <p>{{ pqrAsme.prepared_date ? pqrAsme.prepared_date  : '-' }}</p>
        </v-col>
        <v-col :cols="colValue" md="6" sm="12" xs="12">
          <label class='view_label'>Approved By</label>
          <p>{{ pqrAsme.approved_by ? pqrAsme.approved_by  : '-' }}</p>
          <label class='view_label'>Approved By Signature</label>
          <p>{{ pqrAsme.approved_by_sign ? pqrAsme.approved_by_sign  : '-' }}</p>
          <label class='view_label'>Date</label>
          <p>{{ pqrAsme.approved_date ? pqrAsme.approved_date  : '-' }}</p>
        </v-col>
        <v-col :cols='colValue' md='4' sm='6' xs='12' >
          <label class='view_label'>Status</label>
          <p>
            <template>
              <v-chip :color="pqrAsme.status == 0 ? 'success' : 'warning'" small>{{ pqrAsme.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed class="d-print-none">
        <v-col class="text-right">
          <v-btn v-if="$checkRight(['edit_welding_procedure'])" color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
          <v-btn color="primary" class="mr-2" @click="print" small v-if="!$vuetify.breakpoint.mdAndDown">Print</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    colValue () {
      return this.$vuetify.breakpoint.mdAndDown ? 12 : undefined
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getWeldingProcedureById/' + id).then((res) => {
        const data = res.data.welding_procedure
        data.wptwpr_id = res.data.wptwpr
        data.wptwt_id = res.data.wptwt
        data.base_metal = res.data.base_metal
        data.filler_metal = res.data.filler_metal
        data.welding_parameter = res.data.welding_parameter
        data.welding_procedure_drawing = res.data.welding_procedure_drawing
        const testData = res.data.test_data
        data.tensile_test = testData.tensile_test !== undefined ? testData.tensile_test : []
        data.guided_bend_test = testData.guided_bend_test !== undefined ? testData.guided_bend_test : []
        data.toughness_test = testData.toughness_test !== undefined ? testData.toughness_test : []
        data.other_test = testData.other_test !== undefined ? testData.other_test : []
        data.hardness_test = testData.hardness_test !== undefined ? testData.hardness_test : []
        this.pqrAsme = data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      pqrAsme: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/weldingProcedure/pqrAsme/edit/${editId}`, })
    },
    print () {
      window.print()
    }
  }
}
</script>

<style>
.pqrAsmeViewForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.pqrAsmeViewForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.pqrAsmeViewForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
.logo_box {
  border: 1px dotted #ccc;
  max-width: 200px;
}
.upload_container {
  height: auto;
  width: 100%;
}
.pqrAsmeViewForm h4 {
  color: #464d69;
  font-weight: bold;
}
.jointDrawings img{
  max-width: 100%;
}
@media print {
  .break_page { page-break-before: always }
}
</style>
